import { Directive, Input } from '@angular/core';
import { BaseComponent } from '@vivela/xplat/core';

@Directive()
export abstract class SelectBaseComponent extends BaseComponent {
  @Input() value: unknown;
  @Input() options: unknown[] = [];
  showOptions = false;
}
